mutation CancelDripSequenceForAllEntities(
    $deleteAllProgressionsForDripEditionInput: DeleteAllProgressionsForDripEditionInput!
) {
    deleteAllProgressionsForDripEdition(input: $deleteAllProgressionsForDripEditionInput) {
        edition {
            id
        }
    }
}
